import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type fetchDeclarationModel = {
  id: string | number
}

export const fetchDeclaration = ({ id }: fetchDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveDeclaration = ({ id }: fetchDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateDeclaration = ({ id }: fetchDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/update/${id}`,
    makeAxiosHttpClient()
  )
}

export const resetDeclaration = ({ id }: fetchDeclarationModel) => {
  return new PsychologicalDocumentsUseCase(
    `/declaracao/reset/${id}`,
    makeAxiosHttpClient()
  )
}
